<div class="car-page">
  <div class="car-panel grp-decorated-panel">

    <div class="car-panel__header grp-panel-header">
      <div class="car-panel__header-left">
        <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22"
          style="margin-right: 10px; color: var(--brand-blue);">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span class="grp-title-text">Configuration du Référencement (SEO)</span>
      </div>
    </div>

    <div class="car-panel__body" style="padding: 24px;">

      <ng-template #attente>
        <div class="seo-loader-container">
          <div class="spinner-circle spinner-circle--large"></div>
          <span class="seo-loader-text">Chargement des configurations...</span>
        </div>
      </ng-template>

      <div *ngIf="enregistrementTerminer; else attente">

        <div *ngIf="generalService.cuurentUser != 'BIGDAR'" class="seo-form-container">

          <div class="grp-input-group">
            <label class="seo-label">
              <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
              </svg>
              Description Générale
            </label>
            <textarea class="grp-fancy-input seo-textarea" [(ngModel)]="description" name="seoMetaDescription"
              placeholder="Saisissez la description de la page..." rows="4">
            </textarea>
          </div>

          <div class="grp-input-group">
            <label class="seo-label">
              <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
              </svg>
              Mots-clés (Keywords)
            </label>
            <textarea class="grp-fancy-input seo-textarea seo-textarea--code" [(ngModel)]="keyWords"
              name="seoMetaKeywords" placeholder="Mot-clé 1, Mot-clé 2, Mot-clé 3..." rows="12">
            </textarea>
          </div>

          <div class="seo-action-row">
            <button type="button" (click)="enregistrer()" class="grp-fancy-btn" [disabled]="isSaving">
              <span class="spinner-circle" *ngIf="isSaving"></span>
              Enregistrer les modifications
            </button>
          </div>
        </div>

        <div *ngIf="generalService.cuurentUser == 'BIGDAR'" class="seo-form-container">

          <div class="grp-input-group" style="margin-bottom: 24px;">
            <label class="seo-label">
              <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
              </svg>
              Description Globale (BIGDAR)
            </label>
            <textarea class="grp-fancy-input seo-textarea" [(ngModel)]="description" name="seoBigdarGlobalDescription"
              placeholder="Saisissez la description globale..." rows="4">
            </textarea>
          </div>

          <div class="seo-category-grid">
            <div *ngFor="let cat of listCategorie; let i = index" class="seo-category-card">

              <div class="seo-card-header">
                <span class="seo-category-badge">Catégorie {{ i + 1 }}</span>
                <input type="text" class="seo-read-only-title" [(ngModel)]="cat.categorie_Text" readonly="true"
                  [id]="'id'+i" [name]="'seoCategoryTitle_'+i" />
              </div>

              <div class="grp-input-group" style="padding: 16px;">
                <label class="seo-label-sub">Mots-clés pour {{ cat.categorie_Text | textPipe : 'capitalize' }}</label>
                <textarea class="grp-fancy-input seo-textarea seo-textarea--code" [(ngModel)]="listngModelTextArea[i]"
                  [name]="'seoCategoryKeywords_'+i" [placeholder]="'Saisissez les mots-clés...'" rows="8">
                </textarea>
              </div>

            </div>
          </div>

          <div class="seo-action-row" style="margin-top: 24px;">
            <button type="button" (click)="concateAlltextareaAndPost()" class="grp-fancy-btn" [disabled]="isSaving">
              <span class="spinner-circle" *ngIf="isSaving"></span>
              Enregistrer tout le catalogue
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>